/* ===================================================================
   ALV-NÄKYMÄ  →  assets/vat-toggle.js
   Headerin kytkin: näytä hinnat "sis. ALV" tai "ALV 0 %".
   VAIN VISUAALINEN — ei vaikuta kassaan. Kiinteä kanta 25,5 %.

   Toiminta:
     - Jokainen hintaelementti kantaa data-price="<sentit>" (veroLLINEN hinta).
       JS muotoilee: sis. ALV → sentit sellaisenaan; ALV 0 → round(sentit / 1.255).
     - Tila <html class="vat-excluded"> + localStorage (säilyy sivunvaihdoissa).
     - ALV 0 valittuna → kytkee myös yritysostos-tilan päälle (window.BuyerType),
       koska alviton näkymä on B2B-asia.
     - Kuuntelee cart:rendered-tapahtumaa → korin JS:n piirtämät hinnat päivittyvät.

   HUOM: data-price-attribuutin arvo on AINA verollinen sentti (Shopifyn hinta).
   Tekstiä ei parsita — luetaan raakaluku attribuutista.
   =================================================================== */
(function () {
  'use strict';

  var RATE = 1.255;               // 25,5 % ALV
  var KEY = 'skelte:vat-excluded';
  var THIN = '\u202f', NBSP = '\u00a0';

  var excluded = false;
  try { excluded = localStorage.getItem(KEY) === '1'; } catch (e) {}

  function groupThousands(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function formatMoney(cents) {
    var neg = cents < 0, n = Math.abs(Number(cents) || 0);
    var v = (n / 100).toFixed(2), p = v.split('.');
    return (neg ? '-' : '') + groupThousands(p[0], THIN) + ',' + p[1] + NBSP + '\u20ac';
  }
  function displayCents(inclCents) {
    if (!excluded) return inclCents;
    return Math.round(Number(inclCents) / RATE);
  }

  // Muotoile yksi elementti. data-price = verollinen sentti.
  function apply(el) {
    var raw = el.getAttribute('data-price');
    if (raw === null || raw === '') return;
    var cents = parseInt(raw, 10);
    if (isNaN(cents)) return;
    el.textContent = formatMoney(displayCents(cents));
  }

  // Päivitä kaikki hinnat DOM:ista.
  function applyAll(root) {
    (root || document).querySelectorAll('[data-price]').forEach(apply);
    updateSuffixes(root);
  }

  // ALV-suffiksit (esim. "sis. ALV" / "ALV 0 %") — elementit joilla data-vat-suffix.
  function updateSuffixes(root) {
    (root || document).querySelectorAll('[data-vat-suffix]').forEach(function (el) {
      el.textContent = excluded ? (el.getAttribute('data-vat-ex') || 'ALV 0 %')
                                 : (el.getAttribute('data-vat-in') || 'sis. ALV');
    });
  }

  // Aseta tila + heijasta kaikkiin kytkimiin + päivitä hinnat.
  function setExcluded(on, opts) {
    excluded = !!on;
    try { localStorage.setItem(KEY, excluded ? '1' : '0'); } catch (e) {}
    document.documentElement.classList.toggle('vat-excluded', excluded);

    document.querySelectorAll('[data-vat-switch]').forEach(function (sw) {
      if (sw.type === 'checkbox') sw.checked = excluded;
      sw.setAttribute('aria-checked', excluded ? 'true' : 'false');
    });

    applyAll();

    // Kytkentä yritysostokseen: ALV 0 → yritys päälle. (Ei pakoteta pois takaisin.)
    if (!(opts && opts.silent) && excluded && window.BuyerType && window.BuyerType.setCompany) {
      window.BuyerType.setCompany(true);
    }

    // Ilmoitus (ei alkulatauksessa)
    if (!(opts && opts.silent)) {
      var tt = window.themeT || {};
      showToast(excluded
        ? (tt.vatShownEx || 'Hinnat näytetään nyt ilman veroa')
        : (tt.vatShownIn || 'Hinnat näytetään nyt sisältäen veron'));
    }
  }

  /* ---------- Toast-ilmoitus ---------- */
  var toastEl = null, toastTimer = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'vat-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    // pakota reflow → uudelleenlaukaistava transitio
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2200);
  }

  /* ---------- Kytkin ---------- */
  // Tukee sekä <input type=checkbox> (change) että <button role=switch> (click).
  document.addEventListener('change', function (e) {
    var sw = e.target.closest('input[data-vat-switch]');
    if (!sw) return;
    setExcluded(sw.checked);
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('button[data-vat-switch]');
    if (!sw) return;
    setExcluded(!excluded);
  });

  // Korin JS piirtää hinnat uudelleen → kuuntele ja päivitä.
  document.addEventListener('cart:rendered', function (e) {
    applyAll(e && e.detail && e.detail.root ? e.detail.root : document);
  });

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    document.documentElement.classList.toggle('vat-excluded', excluded);
    setExcluded(excluded, { silent: true }); // alkutila ilman BuyerType-pakotusta
    // Hinnat on nyt muotoiltu → paljasta (poistaa vat-armed-piilotuksen).
    document.documentElement.classList.add('vat-ready');
    document.documentElement.classList.remove('vat-armed');
  });

  window.VAT = {
    isExcluded: function () { return excluded; },
    set: setExcluded,
    displayCents: displayCents,
    format: function (cents) { return formatMoney(displayCents(cents)); },
    applyAll: applyAll
  };
})();